import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@liza/ui/components/ui/dialog';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { AddLabOrderForm } from './AddLabOrderForm';
import { useLabOrderFormData } from './useLabOrderFormData';

type Props = {
  medplumPatientId: string;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
};

export const AddLabOrderDialog = ({ medplumPatientId, isOpen, onOpenChange }: Props): React.ReactNode => {
  const { t } = useTranslation('records');

  const handleClose = useCallback(() => onOpenChange(false), [onOpenChange]);
  const { performingLab, tests, diagnoses, isCreating, onPerformingLabChange, handleCreate } = useLabOrderFormData(
    medplumPatientId,
    { enabled: isOpen, onCreated: handleClose },
  );

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>{t('createLabOrder')}</DialogTitle>
        </DialogHeader>
        <AddLabOrderForm
          performingLab={performingLab}
          tests={tests}
          diagnoses={diagnoses}
          isCreating={isCreating}
          onPerformingLabChange={onPerformingLabChange}
          onCreate={handleCreate}
          onClose={handleClose}
        />
      </DialogContent>
    </Dialog>
  );
};
